//------------------------------------------------------------------
// Description: Message type enum definition. This is used by the client interface to decide whether all messages should
//              be sent or only the latest. See comments for mapping.
//
// Author:      Kiran Saligrama
// 
// Date ------  Developer -- Description ----------------------------
// 25 Oct  2011 SK           Pull out message type definitions from interface file
// 11 Jun  2012 SK           Add error types definition
//------------------------------------------------------------------

var _dscMessageTypes =
{
	confManagementMessage : 0,					//send all messages
	confAttributeMessage : 1,					//send all messages
	confImagePositionUpdateMessage : 2,			//send only latest message
	confMarkerPositionUpdateMessage : 3,		//send only latest message
	confEventUpdateRegistration : 4				//send only latest
};

var _dscErrorTypes =
{
	confMsgError: 0, 		//application level error
	confNetError: 1			//network error sending message
}


